<button
  mui-btn
  appearance="primary"
  class="mui-input__trailing mui-input__trailing__submit-btn inline-button"
  type="submit"
  [id]="id"
  [class.is--saving]="saving"
  [disabled]="disabled"
  (click)="submit()">
  <mui-icon *ngIf="saving" font="fa" name="spinner-third" spinning="true" class="mui-input__trailing__submit-btn__load-icon"></mui-icon>
  <mui-icon *ngIf="!saving" [name]="icon" [font]="iconFont" class="mui-input__trailing__submit-btn__success-icon"></mui-icon>
</button>
